<ng-container *ngIf="selectorTpl != null; else elseTpl">
  <div (click)="setCurrentTime()">
    <ng-container *ngTemplateOutlet="selectorTpl; context: {item: value}"></ng-container>
  </div>
</ng-container>
<ng-template #elseTpl>
  <ion-item [class.invalid]="isInvalid() && isTouched()">
    <label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label>
    <ion-button slot="end" *ngIf="value != null && value != ''; else timeNotSet" fill="clear" class="ion-text-right">{{value}}</ion-button>
    <ng-template #timeNotSet>
      <ion-button slot="end" fill="clear" (click)="setCurrentTime()" class="ion-text-right">Establecer hora actual</ion-button>
    </ng-template>
  </ion-item>
</ng-template>